import Reveal from "@/components/Reveal";

const Manifesto = () => (
  <section className="relative mx-auto max-w-7xl px-6 py-28 md:px-12 md:py-40" data-testid="manifesto-section">
    <div className="grid items-center gap-16 md:grid-cols-12">
      <div className="md:col-span-7">
        <Reveal>
          <p className="mb-6 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
            El proceso invisible
          </p>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-5xl">
            Tu consumidor decide{" "}
            <span className="text-magenta">antes</span> de poder explicar por qué
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-lg text-sm leading-relaxed text-lilac/90 md:text-base">
            Antes de comprarte, cada persona recorre una serie de pequeñas decisiones.
            La mayoría ocurre antes de que pueda explicar racionalmente por qué eligió
            una marca y no otra.
          </p>
        </Reveal>
      </div>
      <div className="md:col-span-5">
        <Reveal delay={0.25}>
          <div className="overflow-hidden border border-white/10">
            <img
              src="/assets/maria-estudio.png"
              alt="No te faltan ideas, te falta dirección. María en su estudio"
              className="w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Manifesto;
